"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7909],{

/***/ 32806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ useVestaParameters; },
  "Xp": function() { return /* binding */ useAllVestaParameters; }
});

// UNUSED EXPORTS: AllVestaParametersDataQueryKey, VestaParametersDataQueryKey, initialParamState

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(50815);
// EXTERNAL MODULE: ./src/components/hooks/_constants.ts
var _constants = __webpack_require__(95915);
// EXTERNAL MODULE: ./src/config/protocol/index.ts + 3 modules
var protocol = __webpack_require__(87055);
// EXTERNAL MODULE: ./src/config/types.ts
var types = __webpack_require__(87859);
// EXTERNAL MODULE: ./src/pages/_app.tsx + 267 modules
var _app = __webpack_require__(60140);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/utils/error/errorHandlers.ts + 1 modules
var errorHandlers = __webpack_require__(73886);
// EXTERNAL MODULE: ./src/utils/error/errors.ts + 3 modules
var errors = __webpack_require__(25926);
;// CONCATENATED MODULE: ./src/services/contracts/vestaParameters.ts






function getVestaParameters(tokenAddress, vpContract) {
    return _getVestaParameters.apply(this, arguments);
}
function _getVestaParameters() {
    _getVestaParameters = (0,_async_to_generator/* default */.Z)(function(tokenAddress, vpContract) {
        var ref, mcr, minNetDebt, vstMintCap, bonusToSp, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Promise.all([
                            vpContract.MCR([
                                tokenAddress
                            ]),
                            vpContract.MIN_NET_DEBT([
                                tokenAddress
                            ]),
                            vpContract.vstMintCap([
                                tokenAddress
                            ]),
                            vpContract.BonusToSP([
                                tokenAddress
                            ])
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        4
                    ]), mcr = ref[0], minNetDebt = ref[1], vstMintCap = ref[2], bonusToSp = ref[3];
                    return [
                        2,
                        {
                            mcr: parseFloat(lib_esm.formatEther(mcr)),
                            minNetDebt: parseFloat(lib_esm.formatEther(minNetDebt)),
                            minNetDebtRaw: minNetDebt,
                            vstMintCap: parseFloat(lib_esm.formatEther(vstMintCap)),
                            vstMintCapRaw: vstMintCap,
                            bonusToSp: parseFloat(lib_esm.formatEther(bonusToSp))
                        }
                    ];
                case 2:
                    err = _state.sent();
                    throw (0,errorHandlers/* makeThrowable */.ye)(errors/* ERROR_MSGS.CT_FETCH_SYS_PARAMS_FAIL */.rI.CT_FETCH_SYS_PARAMS_FAIL);
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getVestaParameters.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/utils/utils.ts
var utils = __webpack_require__(55208);
// EXTERNAL MODULE: ./src/components/hooks/contracts/index.ts + 1 modules
var contracts = __webpack_require__(15812);
// EXTERNAL MODULE: ./src/components/hooks/useSession.ts
var useSession = __webpack_require__(87627);
;// CONCATENATED MODULE: ./src/components/hooks/protocol/useVestaParameters.ts















var initialParamState = {
    bonusToSp: 0,
    mcr: 1.1,
    minNetDebt: 300,
    minNetDebtRaw: BigInt(300 * Math.pow(10, 18)),
    vstMintCap: 0,
    vstMintCapRaw: utils/* BIG_INT_ZERO */.iV
};
var VestaParametersDataQueryKey = "parameters";
var AllVestaParametersDataQueryKey = "all-parameters";
var useVestaParametersData = function(asset) {
    var ref = (0,useSession/* useSession */.k)(), networkId = ref.network.networkId;
    var ref1 = (0,contracts/* useContractVestaParameters */.ZJ)(), vestaParametersRead = ref1.read, vestaParametersAddress = ref1.address;
    var tokenAddress = (0,protocol/* getContractAddress */.CR)(asset, networkId);
    var invalidate = function() {
        return _app.queryClient.refetchQueries([
            VestaParametersDataQueryKey,
            networkId,
            asset
        ]);
    };
    var result = (0,useQuery/* useQuery */.a)([
        VestaParametersDataQueryKey,
        networkId,
        asset
    ], /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                getVestaParameters(tokenAddress, vestaParametersRead)
            ];
        });
    }), {
        retry: function(failureCount, error) {
            if (error.message === errors/* ERROR_MSGS.REACT_QUERY_CANNOT_FETCH */.rI.REACT_QUERY_CANNOT_FETCH || failureCount > 5) return false;
            return true;
        },
        retryDelay: function(attempt) {
            return Math.min(attempt > 1 ? Math.pow(2, attempt) * 1000 : 1000, 30 * 1000);
        },
        staleTime: Infinity,
        refetchOnMount: false,
        enabled: (0,protocol/* checkValidContractAddress */.Ky)([
            tokenAddress,
            vestaParametersAddress
        ])
    });
    var _data;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
        data: (_data = result.data) !== null && _data !== void 0 ? _data : initialParamState,
        invalidate: invalidate
    });
};
var initalAllparams = (0,utils/* setInitialState */.KY)(types/* EVestaAsset */.e2, initialParamState);
//@TODO change to new fetching pattern
var useAllVestaParameters = function() {
    var ref = (0,useSession/* useSession */.k)(), networkId = ref.network.networkId;
    var ref1 = (0,contracts/* useContractVestaParameters */.ZJ)(), vestaParametersRead = ref1.read, vestaParametersAddress = ref1.address;
    var invalidate = function() {
        return _app.queryClient.refetchQueries([
            AllVestaParametersDataQueryKey,
            networkId
        ]);
    };
    var result = (0,useQuery/* useQuery */.a)([
        AllVestaParametersDataQueryKey,
        networkId
    ], /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var paramsData, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Promise.all(protocol/* ActiveCollateralAssets.map */.HJ.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(asset) {
                                var tokenAddress, params;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            tokenAddress = (0,protocol/* getContractAddress */.CR)(asset, networkId);
                                            return [
                                                4,
                                                getVestaParameters(tokenAddress, vestaParametersRead)
                                            ];
                                        case 1:
                                            params = _state.sent();
                                            return [
                                                2,
                                                {
                                                    asset: asset,
                                                    params: params
                                                }
                                            ];
                                    }
                                });
                            });
                            return function(asset) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 1:
                    paramsData = _state.sent();
                    return [
                        2,
                        paramsData.reduce(function(a, b) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, a), (0,_define_property/* default */.Z)({}, b.asset, b.params));
                        }, {})
                    ];
                case 2:
                    err = _state.sent();
                    console.error(err);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), (0,_constants/* queryOptions */.C)(false, (0,protocol/* checkValidContractAddress */.Ky)(vestaParametersAddress)));
    var _data;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), {
        data: (_data = result.data) !== null && _data !== void 0 ? _data : initalAllparams,
        invalidate: invalidate
    });
};
/* harmony default export */ var useVestaParameters = (useVestaParametersData);


/***/ }),

/***/ 93427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useVaultInterestRate; }
/* harmony export */ });
/* unused harmony export vaultInterestRateKey */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20414);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50815);
/* harmony import */ var _components_hooks_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95915);
/* harmony import */ var _components_hooks_contracts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15812);
/* harmony import */ var _components_hooks_useGraphStatus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5693);
/* harmony import */ var _components_hooks_useSession__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87627);
/* harmony import */ var _config_protocol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87055);










var vaultInterestRateKey = "vault-interest-rate-key";
var useVaultInterestRate = function(asset) {
    var network = (0,_components_hooks_useSession__WEBPACK_IMPORTED_MODULE_2__/* .useSession */ .k)().network;
    var ref = (0,_components_hooks_useGraphStatus__WEBPACK_IMPORTED_MODULE_1__/* .useGraphStatus */ .L)(), isGraphFetchable = ref.data;
    var ref1 = (0,_components_hooks_contracts__WEBPACK_IMPORTED_MODULE_0__/* .useContractVestaEIR */ .Dm)(asset), interestRateRead = ref1.read, interestRateAddress = ref1.address;
    var queryKey = [
        vaultInterestRateKey,
        network.networkId,
        asset,
        isGraphFetchable ? "graph" : "chain"
    ];
    var result = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)(queryKey, /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var interestRateRaw;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        interestRateRead.currentEIR()
                    ];
                case 1:
                    interestRateRaw = _state.sent();
                    return [
                        2,
                        Number(interestRateRaw) / (100 * 100)
                    ];
            }
        });
    }), (0,_components_hooks_constants__WEBPACK_IMPORTED_MODULE_7__/* .queryOptions */ .C)(false, (0,_config_protocol__WEBPACK_IMPORTED_MODULE_3__/* .checkValidContractAddress */ .Ky)(interestRateAddress)));
    var _data;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, result), {
        data: (_data = result.data) !== null && _data !== void 0 ? _data : 0
    });
};


/***/ }),

/***/ 62954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useVaultRewardAPR; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(50815);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/unit/formatEther.js
var formatEther = __webpack_require__(6665);
// EXTERNAL MODULE: ./src/components/hooks/_constants.ts
var _constants = __webpack_require__(95915);
// EXTERNAL MODULE: ./src/components/hooks/contracts/index.ts + 1 modules
var contracts = __webpack_require__(15812);
// EXTERNAL MODULE: ./src/components/hooks/useSession.ts
var useSession = __webpack_require__(87627);
// EXTERNAL MODULE: ./src/config/protocol/index.ts + 3 modules
var protocol = __webpack_require__(87055);
// EXTERNAL MODULE: ./src/config/types.ts
var types = __webpack_require__(87859);
// EXTERNAL MODULE: ./src/components/hooks/protocol/assets/useAssetPrices.ts + 4 modules
var useAssetPrices = __webpack_require__(10183);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/config/protocol/contractConfig/index.ts + 4 modules
var contractConfig = __webpack_require__(22044);
// EXTERNAL MODULE: ./src/pages/_app.tsx + 267 modules
var _app = __webpack_require__(60140);
// EXTERNAL MODULE: ./src/components/hooks/protocol/useContractAddress.ts
var useContractAddress = __webpack_require__(58184);
;// CONCATENATED MODULE: ./src/components/hooks/protocol/vaults/useGMXBonus.ts















var QUERY_KEY = "gmx-boosted-apr";
var GMX_REWARD_DEPOSIT_TOKEN_ADDRESS = "0x35247165119B69A40edD5304969560D0ef486921";
var useGMXBonusAPR = function() {
    var ref, ref1;
    var ref2 = (0,useSession/* useSession */.k)(), address = ref2.address, network = ref2.network;
    var ref3 = (0,contracts/* useContractGMXStakingBonus */.Vn)(), gmxStakingBonusRead = ref3.read, gmxStakingBonusAddress = ref3.address;
    var ref4 = (0,contracts/* useContractVaultRewards */.Y5)(types/* EVestaAsset.GMX */.e2.GMX), vaultRewardsRead = ref4.read, vaultRewardsAddress = ref4.address;
    var gmxStakerAddress = (0,useContractAddress/* useContractAddress */.L)(contractConfig/* EContractName.VestaGMXStaking */.wU.VestaGMXStaking);
    var gmxFeeTrackerAddress = (0,useContractAddress/* useContractAddress */.L)(contractConfig/* EContractName.GMXFeeTracker */.wU.GMXFeeTracker);
    var invalidate = function() {
        return _app.queryClient.refetchQueries([
            QUERY_KEY,
            network.networkId,
            address
        ]);
    };
    var res = (0,useQuery/* useQuery */.a)([
        QUERY_KEY,
        network.networkId,
        address
    ], /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, stakedMP, stakedGMX;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            gmxStakingBonusRead.getDepositBalances([
                                gmxStakerAddress,
                                [
                                    GMX_REWARD_DEPOSIT_TOKEN_ADDRESS
                                ],
                                [
                                    gmxFeeTrackerAddress
                                ]
                            ]),
                            vaultRewardsRead.totalStaked()
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), stakedMP = ref[0], stakedGMX = ref[1];
                    return [
                        2,
                        {
                            stakedMP: lib_esm.formatEther(stakedMP[0]),
                            stakedGMX: lib_esm.formatEther(stakedGMX)
                        }
                    ];
            }
        });
    }), (0,_constants/* queryOptions */.C)(false, (0,protocol/* checkValidContractAddress */.Ky)([
        gmxStakingBonusAddress,
        vaultRewardsAddress,
        gmxStakerAddress,
        gmxFeeTrackerAddress, 
    ])));
    var ref5, ref6;
    var boostedApr = Number((ref5 = (ref = res.data) === null || ref === void 0 ? void 0 : ref.stakedMP) !== null && ref5 !== void 0 ? ref5 : 0) / Number((ref6 = (ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.stakedGMX) !== null && ref6 !== void 0 ? ref6 : 0);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res), {
        data: boostedApr,
        invalidate: invalidate
    });
};

;// CONCATENATED MODULE: ./src/components/hooks/protocol/vaults/useVaultRewardAPR.ts
/* eslint-disable prettier/prettier */ 













var RewardAPRQueryKey = "vault-apr";
var useVaultRewardAPR = function(asset) {
    var ref;
    var computedAsset = asset !== types/* EVestaAsset.GMX */.e2.GMX && asset !== types/* EVestaAsset.sGLP */.e2.sGLP ? types/* EVestaAsset.GMX */.e2.GMX : asset;
    var ref1 = (0,useSession/* useSession */.k)(), address = ref1.address, network = ref1.network;
    var ref2 = (0,useAssetPrices/* default */.ZP)(), prices = ref2.data, pricesFetched = ref2.isFetched, isPricesLoading = ref2.isLoading;
    var ref3 = (0,contracts/* useContractFeeTracker */.Kv)(computedAsset), feeTrackerRead = ref3.read, feeTrackerAddress = ref3.address;
    var ref4 = (0,contracts/* useContractVaultRewards */.Y5)(types/* EVestaAsset.GMX */.e2.GMX), vaultRewardsRead = ref4.read, vaultRewardsAddress = ref4.address;
    var bonusApr = useGMXBonusAPR();
    var res = (0,useQuery/* useQuery */.a)([
        RewardAPRQueryKey,
        network.networkId,
        asset,
        address
    ], /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, rewardRate, totalSupply, treasuryFee, vestaFee, tvl, distributedTokensAmount, apr, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (asset !== types/* EVestaAsset.GMX */.e2.GMX && asset !== types/* EVestaAsset.sGLP */.e2.sGLP) return [
                        2,
                        {
                            apr: 0,
                            vestaFee: 0
                        }
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        Promise.all([
                            feeTrackerRead.tokensPerInterval(),
                            feeTrackerRead.totalSupply(),
                            vaultRewardsRead.treasuryFee()
                        ])
                    ];
                case 2:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), rewardRate = ref[0], totalSupply = ref[1], treasuryFee = ref[2];
                    vestaFee = 1 - Number(treasuryFee) / 100 / 100;
                    tvl = prices.oracle[computedAsset] * Number((0,formatEther/* formatEther */.d)(totalSupply));
                    distributedTokensAmount = 86400 * 365 * Number((0,formatEther/* formatEther */.d)(rewardRate)) * prices.oracle.ETH;
                    apr = distributedTokensAmount / tvl;
                    return [
                        2,
                        {
                            apr: apr,
                            vestaFee: vestaFee
                        }
                    ];
                case 3:
                    err = _state.sent();
                    console.error(err);
                    throw new Error("Couldnt get Vault APR");
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), (0,_constants/* queryOptions */.C)(false, pricesFetched && !isPricesLoading && (0,protocol/* checkValidContractAddress */.Ky)([
        feeTrackerAddress,
        vaultRewardsAddress
    ])));
    var ref5;
    var boostApr = ((ref5 = (ref = res.data) === null || ref === void 0 ? void 0 : ref.apr) !== null && ref5 !== void 0 ? ref5 : 0) * (asset === types/* EVestaAsset.GMX */.e2.GMX ? bonusApr.data : 0);
    var realApr = res.data ? (res.data.apr + boostApr) * res.data.vestaFee : 0;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res), {
        data: realApr
    });
};


/***/ }),

/***/ 77184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zk": function() { return /* binding */ initialUserVaultState; }
/* harmony export */ });
/* unused harmony export VaultUserDataQueryKey */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20414);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50815);
/* harmony import */ var _components_hooks_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95915);
/* harmony import */ var _components_hooks_contracts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15812);
/* harmony import */ var _components_hooks_useGraphStatus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5693);
/* harmony import */ var _config_protocol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87055);
/* harmony import */ var _config_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87859);
/* harmony import */ var _pages_app__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60140);
/* harmony import */ var _services_contracts_troves__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98065);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55208);
/* harmony import */ var _graph_useVestaSubgraph__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35612);
/* harmony import */ var _useSession__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87627);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29735);
/* harmony import */ var _assets_useAssetPrices__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10183);

















var initialUserVaultState = {
    status: _types__WEBPACK_IMPORTED_MODULE_9__/* .ETroveStatusGraph.NULL */ .R.NULL,
    collateral: 0,
    debt: 0,
    rawCollateral: _utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .BIG_INT_ZERO */ .iV,
    rawDebt: _utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .BIG_INT_ZERO */ .iV,
    rawUnpaidInterest: _utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .BIG_INT_ZERO */ .iV,
    unpaidInterest: 0,
    accumulatedInterest: 0,
    rawAccumulatedInterest: _utils_utils__WEBPACK_IMPORTED_MODULE_6__/* .BIG_INT_ZERO */ .iV
};
var VaultUserDataQueryKey = "vault-user-data";
var useVaultUserData = function(asset) {
    var ref = (0,_useSession__WEBPACK_IMPORTED_MODULE_8__/* .useSession */ .k)(), userAddress = ref.address, isConnected = ref.isConnected, networkId = ref.network.networkId;
    var ref1 = (0,_assets_useAssetPrices__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(), prices = ref1.data, isPricesLoading = ref1.isLoading, isPricesFetched = ref1.isFetched;
    var graph = (0,_graph_useVestaSubgraph__WEBPACK_IMPORTED_MODULE_7__/* .useVestaSubgraph */ .A)();
    var ref2 = (0,_components_hooks_useGraphStatus__WEBPACK_IMPORTED_MODULE_1__/* .useGraphStatus */ .L)(), isGraphFetchable = ref2.data;
    var assetAddress = (0,_config_protocol__WEBPACK_IMPORTED_MODULE_2__/* .getContractAddress */ .CR)(asset, networkId);
    var queryKey = [
        VaultUserDataQueryKey,
        networkId,
        userAddress,
        asset,
        isGraphFetchable ? "graph" : "chain", 
    ];
    var invalidate = function() {
        return _pages_app__WEBPACK_IMPORTED_MODULE_4__.queryClient.refetchQueries(queryKey);
    };
    var ref3 = (0,_components_hooks_contracts__WEBPACK_IMPORTED_MODULE_0__/* .useContractVaultManager */ .gU)(), vaultManagerRead = ref3.read, vaultManagerAddress = ref3.address;
    var ref4 = (0,_components_hooks_contracts__WEBPACK_IMPORTED_MODULE_0__/* .useContractVestaInterestManager */ .aN)(), interestManagerRead = ref4.read, interestManagerAddress = ref4.address;
    var vaultUserData = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__/* .useQuery */ .a)(queryKey, /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
        var _tmp, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        5,
                        ,
                        6
                    ]);
                    if (!isGraphFetchable) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        graph.user.getUserVault(userAddress, asset, networkId)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        (0,_services_contracts_troves__WEBPACK_IMPORTED_MODULE_5__/* .getChainUserVault */ .UB)({
                            assetAddress: assetAddress,
                            userAddress: userAddress,
                            vaultManagerRead: vaultManagerRead,
                            interestManagerRead: interestManagerRead
                        })
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        _tmp
                    ];
                case 5:
                    err = _state.sent();
                    console.error(err);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    }), (0,_components_hooks_constants__WEBPACK_IMPORTED_MODULE_14__/* .queryOptions */ .C)(false, (0,_config_protocol__WEBPACK_IMPORTED_MODULE_2__/* .checkValidContractAddress */ .Ky)([
        vaultManagerAddress,
        interestManagerAddress
    ]) && isConnected && !isPricesLoading && isPricesFetched));
    var _data;
    var vaultUserDataWithInitial = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, vaultUserData), {
        data: (_data = vaultUserData.data) !== null && _data !== void 0 ? _data : initialUserVaultState
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, vaultUserDataWithInitial), {
        data: {
            vault: vaultUserDataWithInitial.data,
            computed: {
                collateralUsd: vaultUserDataWithInitial.data.collateral * prices.oracle[asset],
                debtUsd: vaultUserDataWithInitial.data.debt * prices.market[_config_types__WEBPACK_IMPORTED_MODULE_3__/* .ENativeAsset.VST */ .tx.VST],
                collateralRatio: vaultUserDataWithInitial.data.collateral * prices.oracle[asset] / vaultUserDataWithInitial.data.debt
            }
        },
        invalidate: invalidate
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (useVaultUserData);


/***/ })

}]);